<template>
  <v-container fluid>

    <v-row class="mt-4 mb-4 title">
      Inventory Transactions
    </v-row>

    <v-row>
      <v-col lg="9">
        <in-process></in-process>
      </v-col>
      <v-col lg="3">
        <categories></categories>
      </v-col>
    </v-row>

    <v-card class="mt-3">
      <stats-block></stats-block>
    </v-card>
    
  </v-container>
</template>

<script>
import InProcess from './in-process'
import Categories from './categories/card'
import StatsBlock from './components/stats-block/Main'

export default {
  components: {
    InProcess,
    Categories,
    StatsBlock
  }
}
</script>